import React from "react";
import { connect } from "react-redux";
import { Layout, Typography } from "antd";
import Logo from "./Logo";
import { toggleCollapsedNav, onMobileNavToggle } from "redux/actions/Theme";
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import utils from "utils";
import NavProfile from "./NavProfile";
import NetworkConnectionInfo from "../NetworkConnectionInfo";
import { useAuth } from "../../services/Auth";
import Sync from "./SyncPanel";
import LocationTracker from "./LocationTracker";
import dayjs from "dayjs";
import { cropStaffName } from "utils/helper";
const { Header } = Layout;
const { Title } = Typography;

export const HeaderNav = (props) => {
  const { navCollapsed, navType, headerNavColor, isMobile, currentTheme } = props;

  const { auth, setAuth } = useAuth();
  const logout = () => {
    setAuth({ isSignedIn: false, data: null });
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === "dark" ? "#00000" : "#ffffff");
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  return (
    <Header className={`app-header ${navMode}`} style={{ backgroundColor: headerNavColor }}>
      <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
        <Logo logoType={navMode} />
        <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <Title level={4}>{cropStaffName(auth.data.name) || ""}</Title>
          </div>
          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <Title level={4}>{dayjs().format("DD-MM-YYYY")}</Title>
          </div>
          <div className="nav-right">
            <LocationTracker />
            <Sync />
            <NetworkConnectionInfo />
            <NavProfile auth={auth} logout={logout} />
          </div>
        </div>
      </div>
    </Header>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction } = theme;
  return { navCollapsed, navType, headerNavColor, mobileNav, currentTheme, direction };
};

export default connect(mapStateToProps, { toggleCollapsedNav, onMobileNavToggle })(HeaderNav);
